import { readMetadata } from './readMetadata';
import { saveMetadata } from './saveMetadata';

export const updateRecordInRegistry = (
    metadataKey: string,
    envelopeKey: string,
    savedAt: number,
    storage: Storage
) => {
    const metadata = readMetadata(metadataKey, storage);

    metadata.registry[envelopeKey] = savedAt;

    saveMetadata(metadataKey, metadata, storage);
};
